import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const UserDashboardApi = createApi({
  reducerPath: "UserDashboardApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    //Start User Dashboard API's--------------------------------------
    getWFOBirthdayData: builder.query({
      query: () => "get_wfo_users_birth_days",
      transformResponse: (response) => response?.data,
    }),
    getWfoWorkAnniversaryData: builder.query({
      query: () => "get_wfo_users_work_anniversary",
      transformResponse: (response) => response?.data,
    }),
    getWfoExitUserData: builder.query({
      query: () => "get_exit_of_wfo_users",
      transformResponse: (response) => response?.data,
    }),
    getAllWfoExitUserData: builder.query({
      query: () => "get_all_exit_users_of_wfo",
      transformResponse: (response) => response?.data,
    }),
    getWfoNewJoineeData: builder.query({
      query: () => "get_newjoinee_of_wfo_users",
      transformResponse: (response) => response?.data,
    }),
    getAllWFHUserData: builder.query({
      query: () => "get_all_wfh_users",
      transformResponse: (response) => response?.data,
    }),
    getSalaryLPAWfoData: builder.query({
      query: () => "get_salary_by_LPA_of_wfo_users",
      transformResponse: (response) => response?.data,
    }),

    getGraphData: builder.query({
      query: ({ caseType }) => {
        let url = `get_user_graph_data_of_wfo`;
        if (caseType) url += `?caseType=${encodeURIComponent(caseType)}`;
        return url;
      },
      transformResponse: (response) => response?.data,
    }),
    //End User Dashboard API's--------------------------------------
  }),
});

export const {
  //user dashboard api
  useGetWFOBirthdayDataQuery,
  useGetWfoWorkAnniversaryDataQuery,
  useGetWfoExitUserDataQuery,
  useGetAllWfoExitUserDataQuery,
  useGetWfoNewJoineeDataQuery,
  useGetAllWFHUserDataQuery,
  useGetSalaryLPAWfoDataQuery,
  useGetGraphDataQuery,
} = UserDashboardApi;

export default UserDashboardApi;
